import axios from "axios";

// 휴대폰 인증 번호
const requestCertifyPhoneApi = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/certify?phone=${parameter.phone}&certifyNumber=${parameter.certifyNumber}`
  );
};
const requestCheckIdApi = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/certify/check-id?id=${parameter}`
  );
};

const requestFindUserId = user => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/certify/search-id?phone=${user.phone}`
  );
};

const requestChangePassword2 = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/certify/change-password2`,
    parameter
  );
};

export {
  requestCertifyPhoneApi,
  requestCheckIdApi,
  requestFindUserId,
  requestChangePassword2
};
